import React from 'react';
import { PageIndicator as PageIndicatorNew } from './PageIndicator';
import { convertOldPageIndicatorProps } from './converter.old';
import type { OldPageIndicatorProps } from './converter.old';

export type PageIndicatorProps = OldPageIndicatorProps;

export const PageIndicator: React.FC<PageIndicatorProps> = (props) => (
  <PageIndicatorNew {...convertOldPageIndicatorProps(props)} />
);
